import { EventSubscriber } from '@verdant-web/common';
export class UndoHistory extends EventSubscriber {
    constructor() {
        super(...arguments);
        this._undoable = [];
        this._undone = [];
        this.undo = async () => {
            const next = this._undoable.pop();
            if (next) {
                const redo = await next();
                if (redo)
                    this._undone.push(redo);
                this.emit('change');
                return true;
            }
            return false;
        };
        this.redo = async () => {
            const next = this._undone.pop();
            if (next) {
                const undo = await next();
                if (undo)
                    this._undoable.push(undo);
                this.emit('change');
                return true;
            }
            return false;
        };
        this.addUndo = (undoPoint) => {
            this._undoable.push(undoPoint);
            this._undone = [];
            this.emit('change');
        };
        this.addRedo = (redoPoint) => {
            this._undone.push(redoPoint);
            this.emit('change');
        };
        this.clear = () => {
            this._undoable = [];
            this._undone = [];
            this.emit('change');
        };
    }
    get canUndo() {
        return this._undoable.length > 0;
    }
    get canRedo() {
        return this._undone.length > 0;
    }
    get undoLength() {
        return this._undoable.length;
    }
    get redoLength() {
        return this._undone.length;
    }
}
//# sourceMappingURL=UndoHistory.js.map